// extracted by mini-css-extract-plugin
export default {"canvasContainer":"Simulation_canvasContainer__Te9s7"};